var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Dollar2_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Dollar2_svg__a",
    d: "M15 7.5v1.875M22.95 7.05a11.25 11.25 0 11-15.9 0 11.25 11.25 0 0115.91 0M15 22.5v-1.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Dollar2_svg__a",
    d: "M11.25 17.819a2.812 2.812 0 002.813 2.813h2.054a2.634 2.634 0 002.633-2.634 2.633 2.633 0 00-1.993-2.554l-3.515-.881a2.633 2.633 0 01-1.992-2.554 2.633 2.633 0 012.634-2.634h2.054a2.812 2.812 0 012.812 2.813"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z",
    fill: "none"
  })));
}

export default SvgDollar2;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Dollar2.svg
// module id = 781
// module chunks = 101